/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskAnnotationStatus } from './taskAnnotationStatus';
import { SendReminderInformation } from './sendReminderInformation';


export interface SharingTask { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    expiryDate: string;
    userEmails: Array<string>;
    publicLink?: boolean;
    description?: string;
    noDownload?: boolean;
    sharedBy?: string;
    branding?: string;
    linkOpenedByUsers?: Array<string>;
    downloadedByUsers?: Array<string>;
    taskId: string;
    taskName?: string;
    taskTransitioned?: boolean;
    annotationStatus: Array<TaskAnnotationStatus>;
    reminderInfo?: Array<SendReminderInformation>;
}

